import { MenuItem, TextField, TextFieldProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useProjects } from '../hooks'
import { Project } from '../types'

type ProjectSelectProps = TextFieldProps & {
  options?: Project[]
  displayEmpty?: boolean
}

export default function ProjectSelect({
  value,
  displayEmpty = true,
  options,
  ...props
}: ProjectSelectProps) {
  const [t] = useTranslation('common')
  const projects = options ?? useProjects()

  return (
    <TextField select name="project" label={t('project')} value={value ?? ''} {...props}>
      {displayEmpty && <MenuItem value="">-</MenuItem>}
      {projects.map((project) => (
        <MenuItem key={project.id} value={project.id}>
          {project.name}
        </MenuItem>
      ))}
    </TextField>
  )
}
